import React, { useState, useEffect, useRef, useCallback } from "react";
import { ReactComponent as LeftArrow } from "../../../../../../assets/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../../../assets/arrow-left-dark.svg";

import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-control-geocoder/dist/Control.Geocoder.css";
import "leaflet-control-geocoder";
import { useStateContext } from "../../../../../../contexts/ThemeContext";
import useLocales from "../../../../../../hooks/useLocales";
import useSettings from "../../../../../../hooks/useSettings";
import { Link } from "react-router-dom";
import AddLocationForm from "./AddLocationForm";
import MarkerIcon from "../../../../../../assets/MainPage/addBlock/marker.svg";
import { useSelector } from "react-redux";

const LocationForm = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { setActiveMainPageNav } = useStateContext();
  const [locations, setLocations] = useState([]);
  const [formDataList, setFormDataList] = useState([]);

  const mapRef = useRef(null);
  const mapInstance = useRef(null);
  const { translate } = useLocales();
  const { themeDirection } = useSettings();

  const addMarker = useCallback((location, index) => {
    const customIcon = L.icon({
      iconUrl: MarkerIcon,
      iconSize: [24, 24],
      iconAnchor: [12, 24],
      popupAnchor: [0, -24],
    });

    const marker = L.marker([location.lat, location.lon], {
      icon: customIcon,
      draggable: true,
    }).addTo(mapInstance.current).bindPopup(`
        <b>${location.title}</b><br>
        ${location.address}<br>
        <a href="https://www.google.com/maps/dir/?api=1&destination=${location.lat},${location.lon}" target="_blank">Get Directions</a>
      `);

    marker.on("dragend", (e) => {
      const { lat, lng } = e.target.getLatLng();
      setLocations(
        locations.map((loc, i) =>
          i === index ? { ...loc, lat, lon: lng } : loc
        )
      );
    });
  }, []);

  const handleAddLocation = async (newLocation) => {
    if (newLocation.lat !== undefined && newLocation.lon !== undefined) {
      setLocations([...locations, newLocation]); // Update shared locations state
      addMarker(newLocation, locations.length);
      setFormDataList([...formDataList, { ...newLocation }]);
    } else {
      console.error("Invalid location data:", newLocation);
    }
  };

  useEffect(() => {
    if (!mapInstance.current && mapRef.current) {
      mapInstance.current = L.map(mapRef.current).setView([0, 0], 2);
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(
        mapInstance.current
      );
      // mapInstance.current.on('click', (e) => {
      //   const { lat, lng } = e.latlng;
      //   setLocations([...locations, { lat, lon: lng }]);
      // });
      mapInstance.current.zoomControl.remove();
      const zoomControl = L.control.zoom({ position: "topright" });
      mapInstance.current.addControl(zoomControl);
      L.Control.geocoder({ position: "topleft" }).addTo(mapInstance.current);
    }
  }, [locations]); // Note: You might need to adjust the dependency array based on your requirements

  useEffect(() => {
    locations.forEach((location, index) => {
      addMarker(location, index);
    });
  }, [locations, addMarker]);

  useEffect(() => {
    setActiveMainPageNav(true);
    return () => {
      setActiveMainPageNav(false);
    };
  }, [setActiveMainPageNav]);

  return (
    <>
      <div className=" md:px-0 mt-10 mb-6 px-6 flex  sm:flex-row items-start sm:items-center justify-between ">
        <div className="flex items-center gap-2">
          <Link
            to={"/dashboard/component"}
            className="flex text-body_copy2 items-center cursor-pointer"
          >
            <div>
              {darkMode ? (
                <LeftArrowDark
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              ) : (
                <LeftArrow
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              )}
            </div>
            <p className="dark:text-color_v1_dark">
              {translate("cms.location")}
            </p>
          </Link>
        </div>
      </div>

      <div className="sm:mt-7 md:px-0 mt-10 mb-6 px-6">
        <div className="map-container">
          <div
            ref={mapRef}
            className="h-96 rounded-lg overflow-hidden shadow-lg"
          />
        </div>
        <AddLocationForm
          handleAddLocation={(formData) => {
            handleAddLocation(formData);
          }}
        />
      </div>
    </>
  );
};
export default LocationForm;
